import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SchemaData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

const SeoSchema = () => {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://thegodpadel.com';

  useEffect(() => {
    // Remove existing schema script if any
    const existingScript = document.querySelector('script[data-schema="true"]');
    if (existingScript) {
      existingScript.remove();
    }

    let schemaData: SchemaData | null = null;

    // Homepage schema
    if (location.pathname === '/' || location.pathname === '') {
      schemaData = {
        '@context': 'https://schema.org',
        '@type': 'SportsActivityLocation',
        name: 'The GodPadel™',
        description: 'The GodPadel™ is a premium indoor padel club concept combining sport, elegance, and community. A refined environment where passion rules the court.',
        url: siteUrl,
        logo: `${siteUrl}/vite.svg`,
        sameAs: [],
        sport: 'Padel Tennis',
        amenityFeature: [
          {
            '@type': 'LocationFeatureSpecification',
            name: 'Premium Indoor Courts',
            value: true
          },
          {
            '@type': 'LocationFeatureSpecification',
            name: 'Luxury Lounge',
            value: true
          },
          {
            '@type': 'LocationFeatureSpecification',
            name: 'Social Community',
            value: true
          }
        ],
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'GB'
        }
      };
    }

    if (schemaData) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'true');
      script.text = JSON.stringify(schemaData);
      document.head.appendChild(script);
    }

    return () => {
      const scriptToRemove = document.querySelector('script[data-schema="true"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname, siteUrl]);

  return null;
};

export default SeoSchema;
